export default __webpack_public_path__ + "static/media/x-icon.e9f35edf.svg";